import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Send } from "lucide-react";
import { api, errMsg, eur, fmtDate, fmtDateTime, openBlob } from "../lib/api";
import { SearchBox, matchQ } from "./common";

function ResendCell({ q, onSent }) {
  const [email, setEmail] = useState(q.email || "");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await api.post(`/quotes/${q.id}/resend`, { email }); toast.success(`Devis ${q.ref} renvoyé à ${email}`); onSent(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex gap-1 min-w-[260px]">
      <input type="email" className="tl-input !py-1" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="e-mail" data-testid={`quote-resend-email-${q.id}`} />
      <button className="tl-btn tl-btn-dark tl-btn-sm" disabled={busy || !email} onClick={send} data-testid={`quote-resend-${q.id}`}><Send size={14} /> Renvoyer</button>
    </div>
  );
}

export function QuoteHistory({ tick }) {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/quotes").then((r) => setRows(r.data));
  useEffect(() => {
    load();
  }, [tick]);
  const shown = rows.filter((x) => matchQ(q, x.ref, x.recipient_name, x.email, x.created_by_name));
  return (
    <div className="tl-card overflow-x-auto" data-testid="quote-history">
      <div className="flex flex-wrap gap-2 items-center justify-between mb-2">
        <h3 className="font-bold uppercase">Historique des devis</h3>
        <SearchBox value={q} onChange={setQ} testid="quote-history-search" />
      </div>
      {!shown.length && <p className="text-sm text-slate-500">Aucun devis.</p>}
      {shown.length > 0 && (
        <table className="tl-table text-sm">
          <thead><tr><th>Référence</th><th>Créé le</th><th>Destinataire</th><th>Prestation du</th><th>Montant</th><th>Envois</th><th /><th /></tr></thead>
          <tbody>
            {shown.map((x) => (
              <tr key={x.id} data-testid={`quote-row-${x.id}`}>
                <td className="tl-mono font-semibold">{x.ref}</td>
                <td>{fmtDateTime(x.created_at)}<div className="text-xs text-slate-500">{x.created_by_name}</div></td>
                <td>{x.recipient_name || "—"}<div className="text-xs text-slate-500">{x.email}</div></td>
                <td>{fmtDate(x.work_date)}</td>
                <td className="tl-mono">{eur(x.sub?.known_total)}</td>
                <td className="text-xs">{(x.sends || []).length ? (x.sends || []).map((s) => <div key={`${s.email}-${s.at}`}>{s.email} · {fmtDateTime(s.at)}</div>) : "Non envoyé"}</td>
                <td><button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => openBlob(`/quotes/${x.id}/pdf`, `${x.ref}.pdf`, true)} data-testid={`quote-download-${x.id}`}><Download size={14} /> PDF</button></td>
                <td><ResendCell q={x} onSent={load} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
